
import { restClient } from '../client';
import { Appointment, User, UserProfile } from '../resources';


export type UnsubmittedSession = {
  appointment: Appointment;
  patient: User;
  patientProfile: UserProfile;
};

export type UnsubmittedSessionsInput = {
  patient_id?: string;
};

export type UnsubmittedSessionsOutput = {
  data: UnsubmittedSession[];
};

export const unsubmittedSessionsRequest = restClient.createRequest<UnsubmittedSessionsInput, UnsubmittedSessionsOutput>({
  url: '/api/v1/appointments/unsubmitted-sessions',
  method: 'GET',
});